import { html } from 'lit';
import { getMonthNames } from '../shared/display';
function getCurrentSemiAnnual() {
    return new Date().getMonth() > 5 ? 2 : 1;
}
export function getCurrentYear() {
    return new Date().getFullYear();
}
export function isCurrentSemiAnnual(semiAnnual) {
    return getCurrentSemiAnnual() === semiAnnual;
}
export function isCurrentYear(year) {
    return getCurrentYear() === year;
}
export function getMonthsTemplate(semiAnnual, locale) {
    return html `${getMonthsForSemiAnnual(semiAnnual, locale)}`;
}
export function getMonthsForSemiAnnual(semiAnnual, locale) {
    if (semiAnnual === 1) {
        return `${getMonthNames(locale).slice(0, 6).join(', ')}`;
    }
    else {
        return `${getMonthNames(locale).slice(6).join(', ')}`;
    }
}
